import React from "react";
import "react-quill/dist/quill.snow.css";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { ucFirst, ucFirstLetter } from "../../../helpers/string_helper";
import { MemberIcon } from "../../../constants/MemberIcon";
import { Clear as ClearIcon } from "@mui/icons-material";
import { withTranslation } from "react-i18next";
import UserProfile from "./userProfile";

const ShowCommentModal = (props) => {
  return (
    <React.Fragment>
      <div className="rejectModal">
        <Modal
          open={props.open}
          onClose={props.handleRejectModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="rejectPopupModal">
          
            <div className="d-flex justify-content-between align-items-center">
              <Typography id="modal-modal-title" variant="h6" component="h2" className="redTxt">
                {props.t("Rejected")}
              </Typography>
              <IconButton onClick={props.handleRejectModal} color="inherit">
                <ClearIcon />
              </IconButton>  
            </div>
              {/* {ucFirstLetter(props.module)} rejected by {props?.data?.userName} */}
              <div className="rejected_modal_body mt-3">
                <div className="d-flex align-items-center">
                  <UserProfile user={props?.data} avatarClassName='me-2 ml-2' profileClassName='me-2 ml-2' profileStyle ={{height: '40px', width: '40px', fontSize: '18px'}}/>
                  <div className="concern_person">
                    <h5 className="mb-0">{props?.data?.name}</h5>
                    <small>{ucFirst(props?.data?.role)}</small>
                  </div>
                </div>
                <Typography id="modal-modal-description" sx={{ my: 2 }}>
                  {props.t("Reason") + ":"} {ucFirstLetter(props.data?.comment)}
                </Typography>
              </div>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ShowCommentModal);
